// extracted by mini-css-extract-plugin
module.exports = {"container":"e__x","label":"e_0x","icon":"e_1x"};